import { useOktaAuth } from '@okta/okta-react'
import { setOktaPreview } from '~/shared/config/auth'

export function useLogout() {
  const { oktaAuth } = useOktaAuth()

  const logout = () => {
    if (oktaAuth) {
      setOktaPreview(false)
      oktaAuth.signOut()
    }
  }

  return { logout }
}
